import { render, staticRenderFns } from "./MiniDepStatTableDepAmounts.component.vue?vue&type=template&id=092672d8&scoped=true&"
import script from "./MiniDepStatTableDepAmounts.component.vue?vue&type=script&lang=js&"
export * from "./MiniDepStatTableDepAmounts.component.vue?vue&type=script&lang=js&"
import style0 from "./MiniDepStatTableDepAmounts.component.vue?vue&type=style&index=0&id=092672d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092672d8",
  null
  
)

export default component.exports